module.exports = __webpack_public_path__ + "static/prlaw-form-0cec34a13acaa64b7f08cff45fe8cca6.pdf";